import { render } from "./Dashboard.vue?vue&type=template&id=0a9fa30e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0a9fa30e&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=0a9fa30e&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9fa30e"]])

export default __exports__